function playlistType(str) {
  return str.trim();
}

module.exports = playlistType;
